import { render, staticRenderFns } from "./MaterialAplicadoPanel.vue?vue&type=template&id=59da2be4&scoped=true&"
import script from "./MaterialAplicadoPanel.vue?vue&type=script&lang=js&"
export * from "./MaterialAplicadoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da2be4",
  null
  
)

export default component.exports